// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketPharma() {
     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Pharma</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>      
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}

                                                   <img src="assets/images/Market-Images/05.webp" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Pharmaceutical Industry</span></h1>
                                                </div> 
                                                <div className="text bdFadeUp">
                                                    <span>Precision Cooling Solutions for Pharma Excellence</span>
                                                    <p className="top">
                                                      Indus Refrigeration is a trusted partner to the pharmaceutical industry, delivering advanced industrial refrigeration systems tailored to meet the stringent regulatory and environmental requirements of pharma manufacturing and storage. With over four decades of engineering excellence, Indus specializes in custom-designed cold storage and process cooling solutions that ensure product integrity, temperature stability, and energy efficiency across all stages of pharmaceutical production and distribution.
                                                    </p>
                                                    <p>
                                                      From temperature-sensitive APIs (Active Pharmaceutical Ingredients) to vaccine preservation and cleanroom climate control, Indus systems are engineered for ultra-reliable performance and compliance with global standards such as WHO-GMP, US FDA, and EU GMP. Our refrigeration solutions help pharmaceutical companies maintain controlled environments in bulk drug manufacturing units, formulation plants, biotech labs, and warehousing facilities.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for the Pharma Sector:</h2>
                                                </div>
                                                    <p>Low-temperature and ultra-low-temperature cold rooms (as low as -40°C)</p>

                                                    <p>Glycol and brine-based chilling systems for process applications</p>

                                                    <p>HVAC systems for cleanrooms and sterile production areas</p>

                                                    <p>Precision temperature and humidity control systems</p>

                                                    <p>Customized AHUs, chillers, and air-cooled/ water-cooled condensers</p>

                                                    <p>Turnkey projects including design, fabrication, installation, and AMC</p>

                                                    <p>With deep expertise in thermal engineering and a commitment to innovation, Indus Refrigeration ensures uninterrupted cooling, energy savings, and sustainable operations — helping pharma clients meet the highest standards of product quality, patient safety, and operational excellence.</p>

                                               </div>    
                                        </div>
                                    </div>
                                 
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketPharma;


